import {
  Component,
  OnInit,OnDestroy
} from '@angular/core';
import {
  Location
} from '@angular/common';
import {
  AccountService,
} from '../../../_services';
import {
  Router,
  ActivatedRoute
} from '@angular/router';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
} from '@angular/forms';
import {
  validate
} from 'fast-xml-parser';
import {Subscription} from 'rxjs';
import {WebServiceParam} from  '../../../_models/web-service-param';

@Component({
  templateUrl: 'dgx-xml-response.component.html',
  styleUrls: ['../../../../assets/css/common.css'],
})
export class DGXXMLResponseComponent implements OnInit,OnDestroy {
  isLoading:boolean=false;
  webServiceParam: WebServiceParam[]=[];
  users = null;
  returnUrl: string;
  xmlRequest: any;
  routeXmlResponse: any;
  form: UntypedFormGroup;
  sub: any;
  file: any;
  title: string;
  validateRequest: boolean = false;
  validateResponse: boolean = false;
  ErrorResponse: boolean = false;
  code: string;
  msg: string;
  line: number;
  private webServiceParamStatusSub:Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService,
    private formBuilder: UntypedFormBuilder,
    private _location: Location
  ) {}
  ngOnInit() {

    this.isLoading=true; 
    this.form = this.formBuilder.group({
      routeXmlContent: ['']
    });

    this.webServiceParamStatusSub=  this.accountService.getWebServiceParamUpdateListener().subscribe((serviceData:{webServiceParam:WebServiceParam[]}) =>{
     this.webServiceParam=serviceData.webServiceParam;
     console.log(this.webServiceParam);
     console.log(this.webServiceParam['serviceResponseXmlContent']);
  var formattedXmlResponseContent = this.accountService.beautify(this.webServiceParam["serviceResponseXmlContent"],'xml',false);
      console.log(this.webServiceParam["serviceXmlValidateResponse"]);
   if (this.webServiceParam["serviceXmlValidateResponse"]== true) {
       var result = validate(formattedXmlResponseContent);
       if (result != true) {
         this.isLoading=false;
         console.log("result false");
         this.ErrorResponse = true;
         var obj = result.err;
         this.code = obj.code;
         this.msg = obj.msg;
         this.line = obj.line;
         this.form.patchValue({
           routeXmlContent: formattedXmlResponseContent
         });
         this.routeXmlResponse=formattedXmlResponseContent
         this.title=this.webServiceParam['serviceTitleXmlContent'];
         return;
       }
       }
       
        if(formattedXmlResponseContent){
          this.isLoading=false;
          this.form.patchValue({
            routeXmlContent: formattedXmlResponseContent
            });
          this.routeXmlResponse= formattedXmlResponseContent
          this.title=this.webServiceParam['serviceTitleXmlContent'];
        }
  
   });


 
  }


  ngOnDestroy()
 {
   this.webServiceParamStatusSub.unsubscribe();
 }
  backClicked() {
    this._location.back();
  }


}